export class BoolIntRes {
   constructor(b, i){
      this.boolVal = b;
      this.intVal = i;
   }

   static createForNone(){
      return new BoolIntRes(false, 0)
   }

   static createForFalse(i){
      return new BoolIntRes(false, i)
   }

   static createForTrue(i){
      return new BoolIntRes(true, i)
   }

   static createForZero(b){
      return new BoolIntRes(b, 0)
   }
}